import React from "react";

// Define props interface
interface SimpleButtonProps {
	onClick?: () => void;
	className?: string;
	style?: React.CSSProperties;
	children?: React.ReactNode;
}

const SimpleButton: React.FC<SimpleButtonProps> = ({
	onClick = () => {},
	className = "border border-primary-inactive rounded-full px-6 py-2",
	style,
	children = []
}) => {
	return (
		<button
			aria-label="Button"
			onClick={onClick}
			className={`${className} flex items-center justify-center space-x-2`}
			style={style}
		>
			{children}
		</button>
	);
};

export default SimpleButton;
